export const CURRENCY_CODE_US = 'USD';
export const CURRENCY_CODE_CA = 'CAD';
export const LOCALE_US = 'en-US';
export const LOCALE_CA = 'en-CA';
export const LOCALE_DE = 'de-DE';
export const LOCALE_FR = 'fr-FR';
export const LOCALE_DEFAULT = LOCALE_US;
export const CURRENCY_CODE_DEFAULT = CURRENCY_CODE_US;
